import React from "react";
import { Select } from 'antd';
const { Option } = Select;

const renderOption = (item) => <Option key={item} value={item}>{item}</Option>;

export default renderOption;
